import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var dhtmlXCalendarObject: any;

export class featurePointsAssigneeEdit_template extends vnTemplate {

    public validationsList: validationsList_template;
    public calendar;

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">

                <h3 class="form-title icon i-user">Edit Assignee</h3>

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close" type="button"></button>
            </div>
            ` + this.validationsList.getHtmlBuild()  + `
            <div  class="w-list-results" id="list-results"  data-bind="" style="position: relative">
                <div class="form-body full-width">
                    <strong class="form-sub-title">Values</strong>
                    <div class="form-group">
                        <label for="assigneeName" class="form-label">Name</label>
                        <input id="assigneeName" data-bind="value: name, disable: true" type="text" class="input-text">
                     </div>
                    <div class="form-group">
                        <label for="assigneeFeaturePointMultiplier" class="form-label" >Feature Points Multiplier</label>
                        <input id="assigneeFeaturePointMultiplier" data-bind="value: featurePointMultiplier, attr: {min: 0, step: 0.50}" type="number" class="input-text">
                    </div>
                    <div class="form-group">
                        <label for="departmentSelect" class="form-label" >Department</label>
                        <select id="departmentSelect" class="input-text" name="departmentSelect" data-bind="
                            options: departmentOptions,
                            optionsText: 'name',
                            optionsValue: 'id',
                            selectedOptions: [idDepartment()],
                            event: {change: onChangeDepartment}"
                        ></select>
                    </div>
                    <div class="form-group">
                        <label for="isExcludedFromReportSelect" class="form-label" >Report Inclusion</label>
                        <select id="isExcludedFromReportSelect" class="input-text" name="isExcludedFromReportSelect" data-bind="
                            options: reportVisibilityOptions,
                            optionsText: 'name',
                            optionsValue: 'id',
                            selectedOptions: [isExcludedFromReport()],
                            event: {change: onChangeIsExcludedFromReport}"
                        ></select>
                    </div>
                    <div class="form-group">
                        <label class="form-label" id="assigneeStartDate">Work Start Date</label>
                        <input class="input-text" type="date" id="assigneeStartDate" name="assigneeStartDate" onkeydown="return false" data-bind="value: workStartDate, attr: { max: '9999-12-31' }">
                    </div>
                    <div class="form-group">
                        <label class="form-label" id="assigneeEndDate">Work End Date</label>
                        <input class="input-text" type="date" id="assigneeEndDate" name="assigneeStartDate" onkeydown="return false" data-bind="value: workEndDate, attr: { max: '9999-12-31' }">
                    </div>
                    <hr>
                    <strong class="form-sub-title">Days Off</strong>
                    <div class="fixHeightContainer" style="height: 185px; overflow:auto">
                    <!-- ko foreach: vacationPeriods -->
                        <div class="form-group" style="display:flex; justify-content:space-between;">
                            <div>
                                <label class="form-label" data-bind="attr: { id: 'vacationStartDate_' + $index() }">Start Date</label>
                                <!-- ko ifnot: isSaved -->
                                <input class="input-text" type="date" name="vacationStartDate" onkeydown="return false" data-bind="value: startDate, attr: { id: 'vacationStartDate_' + $index(), min: '2021-01-01', max: '2099-12-31'  }">
                                <!-- /ko -->
                                <!-- ko if: isSaved -->
                                <input class="input-text" style="color: #085070" type="text" name="vacationStartDate" onkeydown="return false" disabled="disabled" data-bind="value: startDate">
                                <!-- /ko -->
                            </div>
                            <div>
                                <label class="form-label" data-bind="attr: { id: 'vacationEndDate_' + $index() }">End Date</label>
                                <!-- ko ifnot: isSaved -->
                                <input class="input-text" type="date" name="vacationEndDate" onkeydown="return false" data-bind="value: endDate, attr: { id: 'vacationEndDate_' + $index(), min: '2021-01-01', max: '2099-12-31' }">
                                <!-- /ko -->
                                <!-- ko if: isSaved -->
                                <input class="input-text" style="color: #085070" type="text" name="vacationEndDate" onkeydown="return false" disabled="disabled" data-bind="value: endDate">
                                <!-- /ko -->
                            </div>
                            <div style="margin-top: auto;">
                                <button data-bind="event: { click: $parent.onClickRemoveVacation.bind($data, $index(), $data)}" class="btn" type="button">Delete</button>
                            </div>
                        </div>
                    <!-- /ko -->
                    </div>
                    <div class="form-group" style="margin-top: 1em;">
                        <button data-bind="click: onClickAddVacation" class="btn" type="button">Add</button>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button class="btn" type="button" data-bind="click: onClickCancel">Cancel</button>
                <button class="btn highlight" type="button" data-bind="click: onClickSave">Save</button>
            </div>        
        `;
    }

    protected buildViewModel(): any {
        let huit_neuf_this = this;
        let viewModel = {
            idAssignee: ko.observable()
            ,name: ko.observable("")
            ,departmentOptions: ko.observableArray([])
            ,idDepartment: ko.observable(null)
            ,workStartDate: ko.observable(null)
            ,workEndDate: ko.observable(null)
            ,reportVisibilityOptions: ko.observableArray([{id: 0, name: "Include"}, {id: 1, name: "Exclude"}])
            ,featurePointMultiplier: ko.observable(null)
            ,isExcludedFromReport: ko.observable(0)
            ,vacationPeriods: ko.observableArray([])
            ,onClickAddVacation: function(){ huit_neuf_this.onClickAddVacation(); }
            ,onClickRemoveVacation: function(index, data){ huit_neuf_this.onClickRemoveVacation(index); }
            ,onChangeDepartment: function(data,event){ huit_neuf_this.onChangeDepartment(event); }
            ,onChangeIsExcludedFromReport: function(data,event){ huit_neuf_this.onChangeIsExcludedFromReport(event); }
            ,onClickCancel: function(){ huit_neuf_this.onClickCancel(); }
            ,onClickSave: function(){ huit_neuf_this.onClickSave(); }
            ,isResultsLoading: ko.observable(0)
        }

        return viewModel;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-form", "margin-top"];
    }

    public getViewModelForRequest() {
        return {
            idAssignee: this.getTemplateViewModel().idAssignee,
            name: this.getTemplateViewModel().name,
            idDepartment: this.getTemplateViewModel().idDepartment,
            workStartDate: this.getTemplateViewModel().workStartDate,
            workEndDate: this.getTemplateViewModel().workEndDate,
            featurePointMultiplier: this.getTemplateViewModel().featurePointMultiplier,
            isExcludedFromReport: this.getTemplateViewModel().isExcludedFromReport,
            vacationPeriods: this.getTemplateViewModel().vacationPeriods
        }
    }

    public setupReferences(departments){

        this.setDepartmentItems(departments);
    }

    public setDepartmentItems(departments){

        let intDepartments = departments.map(function (dept) {
            return { id: parseInt(dept.id), name: dept.name}
        });
        intDepartments.unshift({id: null, name: 'None'})

        this.getTemplateViewModel().departmentOptions(intDepartments);
    }

    public setIdAssignee(idAssignee) {

        this.getTemplateViewModel().idAssignee(idAssignee);
    }

    public setAssigneeProperties(assigneeProperties): void {

        this.getTemplateViewModel().idAssignee(assigneeProperties.id);
        this.getTemplateViewModel().name(assigneeProperties.name);
        this.getTemplateViewModel().idDepartment(parseInt(assigneeProperties.idDepartment));
        this.getTemplateViewModel().workStartDate(assigneeProperties.workStartDate);
        this.getTemplateViewModel().workEndDate(assigneeProperties.workEndDate);
        this.getTemplateViewModel().featurePointMultiplier(assigneeProperties.featurePointMultiplier);
        this.getTemplateViewModel().isExcludedFromReport(assigneeProperties.isExcludedFromReport);

        let vacationPeriods = [];
        for (let vacationPeriod of assigneeProperties.vacationPeriods){


            vacationPeriod.isSaved = true;
            vacationPeriods.push(vacationPeriod);
        }

        this.getTemplateViewModel().vacationPeriods(vacationPeriods);
    }

    protected getTemplateName(): string {
        return "featurePointsAssigneeEdit_template";
    }

    private onClickAddVacation(){
        this.getTemplateViewModel().vacationPeriods.unshift({startDate:null,endDate:null,isSaved:false});
    }

    private onClickRemoveVacation(index){
        this.getTemplateViewModel().vacationPeriods.splice(index,1);
    }

    private onChangeDepartment(event){

        this.getTemplateViewModel().idDepartment(parseInt(event.target.value));
    }

    private onChangeIsExcludedFromReport(event){
        this.getTemplateViewModel().isExcludedFromReport(parseInt(event.target.value));
    }

    private onClickCancel(){
        this.caller.cancelAssigneeEdit();
    }

    private onClickSave(){

        this.caller.saveAssignee();
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/featurePointsAssigneeEdit_template.ts